




























































































































import { get, sumBy } from 'lodash';

import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoPrice from '../../Atoms/co-price/coPrice.vue';
import CoDate from '../co-date/CoDate.vue';
import CoTable from '../co-table/CoTable.vue';

export default {
    name: 'CoInvoiceDetail',
    components: { CoTable, CoHeadline, CoDate, CoPrice },
    props: {
        invoice: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        items() {
            if (!this.invoice || !this.invoice.InvoiceLines) {
                return [];
            }
            return this.invoice.InvoiceLines.map((item) => ({
                ...item,
                // Upcoming invoices can contain zero-priced lines without an Amount field.
                // Normalize them here so the table and tax footer stay stable.
                Amount: this.getLineAmount(item),
                AmountBeforeTax: this.getLineNetAmount(item),
            }));
        },
        tax() {
            const taxSummary = {};

            this.items.forEach((item) => {
                const taxRates = Array.isArray(item.TaxRates) ? item.TaxRates : [];

                taxRates.forEach((taxRate) => {
                    const percentage = get(taxRate, 'Percentage', 0);

                    if (!taxSummary[percentage]) {
                        taxSummary[percentage] = {
                            netAmount: 0,
                            taxAmount: 0,
                        };
                    }

                    taxSummary[percentage].netAmount += this.getLineNetAmount(item);
                    taxSummary[percentage].taxAmount += this.getLineTaxAmount(item, percentage);
                });
            });

            const taxRates = Object.keys(taxSummary);
            if (taxRates.length === 1 && Number.isFinite(this.invoice?.Tax)) {
                taxSummary[taxRates[0]].taxAmount = this.invoice.Tax;
            }

            return taxSummary;
        },
        subtotal() {
            if (Number.isFinite(this.invoice?.SubtotalExcludingTax)) {
                return this.invoice.SubtotalExcludingTax;
            }

            if (Number.isFinite(this.invoice?.Subtotal)) {
                return this.invoice.Subtotal;
            }

            return sumBy(this.items, 'AmountBeforeTax');
        },
    },
    methods: {
        getLineAmount(item) {
            return Number.isFinite(item?.Amount) ? item.Amount : 0;
        },
        getLineNetAmount(item) {
            if (Number.isFinite(item?.AmountBeforeTax)) {
                return item.AmountBeforeTax;
            }

            return this.getLineAmount(item);
        },
        getLineTaxAmount(item, percentage) {
            const netAmount = this.getLineNetAmount(item);
            const amount = this.getLineAmount(item);

            if (Number.isFinite(item?.Amount) && Number.isFinite(item?.AmountBeforeTax) && amount !== netAmount) {
                return amount - netAmount;
            }

            return Math.round(netAmount * (percentage / 100));
        },
    },
};
